import axios from 'axios'
import {
    SYSTEM_SETTING_LIST_REQUEST,
    SYSTEM_SETTING_LIST_SUCCESS,
    SYSTEM_SETTING_LIST_FAIL,
    SYSTEM_SETTING_DETAILS_REQUEST,
    SYSTEM_SETTING_DETAILS_SUCCESS,
    SYSTEM_SETTING_DETAILS_FAIL,
    SYSTEM_SETTING_UPDATE_REQUEST,
    SYSTEM_SETTING_UPDATE_SUCCESS,
    SYSTEM_SETTING_UPDATE_FAIL,
    SYSTEM_SETTING_CREATE_REQUEST,
    SYSTEM_SETTING_CREATE_SUCCESS,
    SYSTEM_SETTING_CREATE_FAIL,
    SYSTEM_SETTING_DELETE_REQUEST,
    SYSTEM_SETTING_DELETE_SUCCESS,
    SYSTEM_SETTING_DELETE_FAIL,
    SYSTEM_SETTING_DTO_REQUEST,
    SYSTEM_SETTING_DTO_SUCCESS,
    SYSTEM_SETTING_DTO_FAIL,
} from '../constants/systemSettingConstants'

// Helper functions
const getAuthConfig = (token) => ({
    headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`
    }
});

const formatErrorMessage = (error) => {
    const errorMessages = [];
    if (error.response?.data) {
        if (error.response.data.errors) {
            Object.entries(error.response.data.errors).forEach(([key, value]) => {
                errorMessages.push(`${key}: ${value[0]}`);
            });
        }
        if (error.response.data.detail) {
            errorMessages.push(`Detail: ${error.response.data.detail}`);
        }
        if (error.response.data.message) {
            errorMessages.push(`Message: ${error.response.data.message}`);
        }
    }
    return errorMessages.length > 0 ? errorMessages : [error.message || "An error occurred, please try again later"];
};

const API_BASE_URL = '/dotnet_api/v1/SystemSetting';

export const listSystemSettings = (filter = {}) => async (dispatch, getState) => {
    try {
        dispatch({ type: SYSTEM_SETTING_LIST_REQUEST })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            ...getAuthConfig(userInfo.token),
            params: filter,
        }

        const { data } = await axios.get(`${API_BASE_URL}/all`, config)

        dispatch({
            type: SYSTEM_SETTING_LIST_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: SYSTEM_SETTING_LIST_FAIL,
            payload: formatErrorMessage(error)[0],
        })
    }
}

export const getSystemSettingDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: SYSTEM_SETTING_DETAILS_REQUEST })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            ...getAuthConfig(userInfo.token)
        }

        const { data } = await axios.get(`${API_BASE_URL}/${id}`, config)

        dispatch({
            type: SYSTEM_SETTING_DETAILS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: SYSTEM_SETTING_DETAILS_FAIL,
            payload: formatErrorMessage(error)[0],
        })
    }
}

export const updateSystemSetting = (id, settings) => async (dispatch, getState) => {
    try {
        dispatch({ type: SYSTEM_SETTING_UPDATE_REQUEST })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            ...getAuthConfig(userInfo.token),
        }

        const { data } = await axios.patch(`${API_BASE_URL}/${id}`, settings, config)

        dispatch({
            type: SYSTEM_SETTING_UPDATE_SUCCESS,
            payload: data,
        })
        return data
    } catch (error) {
        dispatch({
            type: SYSTEM_SETTING_UPDATE_FAIL,
            payload: formatErrorMessage(error),
        })
        throw formatErrorMessage(error)
    }
}

export const createSystemSetting = (settings) => async (dispatch, getState) => {
    try {
        dispatch({ type: SYSTEM_SETTING_CREATE_REQUEST })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            ...getAuthConfig(userInfo.token),
        }

        const { data } = await axios.post(API_BASE_URL, settings, config)

        dispatch({
            type: SYSTEM_SETTING_CREATE_SUCCESS,
            payload: data,
        })
        return data
    } catch (error) {
        dispatch({
            type: SYSTEM_SETTING_CREATE_FAIL,
            payload: formatErrorMessage(error),
        })
        throw formatErrorMessage(error)
    }
}

export const deleteSystemSetting = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: SYSTEM_SETTING_DELETE_REQUEST })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            ...getAuthConfig(userInfo.token),
        }

        await axios.delete(`${API_BASE_URL}/${id}`, config)

        dispatch({
            type: SYSTEM_SETTING_DELETE_SUCCESS,
        })
    } catch (error) {
        dispatch({
            type: SYSTEM_SETTING_DELETE_FAIL,
            payload: formatErrorMessage(error)[0],
        })
    }
}

export const getSystemSettingByKey = (settingKey) => async (_dispatch, getState) => {
    const {
        userLogin: { userInfo },
    } = getState();

    try {
        const { data } = await axios.get(
            `${API_BASE_URL}/by-key/${encodeURIComponent(settingKey)}`,
            getAuthConfig(userInfo.token)
        );

        return data;
    } catch (error) {
        if (error.response?.status === 404) {
            return null;
        }
        throw error;
    }
};

export const getSystemSettingDto = () => async (dispatch, getState) => {
    try {
        dispatch({ type: SYSTEM_SETTING_DTO_REQUEST })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            ...getAuthConfig(userInfo.token),
        }

        const { data } = await axios.get(`${API_BASE_URL}/systemSettingDto`, config)

        dispatch({
            type: SYSTEM_SETTING_DTO_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: SYSTEM_SETTING_DTO_FAIL,
            payload: formatErrorMessage(error)[0],
        })
    }
}